<template>
  <div class="field-item" :class="control.wholeLine ? 'item-rich' : ''">
    <div class="label">
      <span>{{ control.name }}</span>
      <!-- 控件提示 -->
      <el-tooltip v-if="control.description" :content="control.description" placement="bottom">
        <span class="icon-tip pointer">
          <i class="el-icon-info"></i>
        </span>
      </el-tooltip>
      <template v-if="control._type === 'file'">
        <el-tooltip content="历史版本">
          <span @click="showFileHistory" class="icon-tip pointer">
            <svg-icon icon-class="svgo_history" style="font-size: 18px"></svg-icon>
          </span>
        </el-tooltip>
        <el-tooltip content="批量下载">
          <span @click="batchDownload" class="icon-tip pointer">
            <i class="el-icon-download"></i>
          </span>
        </el-tooltip>
      </template>
    </div>
    <div class="value">
      <span v-if="isEmpty" class="is-empty">未填写</span>
      <template v-else-if="control._type === 'file'">
        <file-control
          ref="fileControl"
          :files="simpleMode ? [] : value"
          :array="control.displayType === 'list'"
          :control="control"
        ></file-control>
        <span v-if="simpleMode" class="pointer file-button" @click="showFilesInDialog">
          {{ stringValue }}
        </span>
      </template>
      <template v-else-if="control._type === 'sign'">
        <div v-if="value" class="sign">
          <img style="width: 100%;" :src="url_prefix + value.path" />
        </div>
      </template>
      <template v-else-if="control._type === 'rate'">
        <rate :value="parseInt(value) || 0" disabled :control="control"></rate>
      </template>
      <template v-else-if="control._type === 'check'">
        <el-checkbox :value="stringValue === '选中'" disabled class="check"></el-checkbox>
      </template>
      <template v-else-if="control._type === 'url'">
        <el-link :underline="false" type="primary" :href="value" target="_blank">
          {{ value }}
        </el-link>
      </template>
      <template v-else-if="control._type === 'progress'">
        <el-progress
          class="progress"
          :percentage="value >= 0 ? value : 0"
          :type="control.optionStyle === '条形' ? 'line' : 'circle'"
        ></el-progress>
      </template>
      <template v-else-if="control._type === 'ref'">
        <ref-control v-if="control.oneFlag" :control="control" :list="localValue"></ref-control>
        <span v-else>{{ stringValue }}</span>
      </template>
      <span v-else-if="control._type === 'option'" v-tip="simpleMode">
        <template v-if="hasColor">
          <template v-for="(item, index) in value">
            <span :key="index" :class="['option-item-colorful', colorMap[item]]">
              {{ item }}
            </span>
            <span :key="'1-' + index" v-if="value.length - 1 !== index">
              ,
            </span>
          </template>
        </template>
        <template v-else>
          <span v-for="(item, index) in value" :key="index" style="margin-right: 5px">
            {{ item }}
            <span v-if="value.length - 1 !== index">,</span>
          </span>
        </template>
      </span>
      <span v-else-if="control._type === 'rich'" v-viewer="{ backdrop: 'static' }">
        <span
          v-tip="simpleMode"
          v-html="simpleMode ? stringValue : value"
          class="rich-field"
        ></span>
      </span>
      <span v-else-if="control._type === 'remark'" v-viewer="{ backdrop: 'static' }">
        <span v-html="control.hint" class="rich-field"></span>
      </span>
      <span
        v-else-if="['company', 'department'].includes(control._type)"
        style="display: flex; flex-wrap: wrap;"
      >
        <span
          v-for="(item, index) in localValue.split(',')"
          :key="index"
          style="margin-right: 2px; margin-bottom: 2px"
          class="center"
          :class="item ? 'background' : ''"
        >
          <svg-icon v-if="item" :icon-class="'field_' + control._type"></svg-icon>
          <span style="margin-left: 4px">{{ item }}</span>
        </span>
      </span>
      <span v-else-if="control._type === 'staff'" style="display: flex; flex-wrap: wrap;">
        <span v-for="(item, index) in localValue" :key="index" style="display: flex">
          <staff-popover :staffId="item.id" style="margin-bottom: 2px;">
            <template v-slot:reference>
              <div class="center" :class="item ? 'background-user' : ''">
                <staff-avatar size="small" :user="item"></staff-avatar>
                <span style="margin-left: 4px">{{ item.name }}</span>
              </div>
            </template>
          </staff-popover>
        </span>
      </span>
      <staff-popover
        v-else-if="['creator', 'updateUser', 'owner'].includes(control._cid)"
        :staffId="value.id"
      >
        <template v-slot:reference>
          <div class="center" :class="value ? 'background-user' : ''">
            <staff-avatar size="small" :user="value"></staff-avatar>
            <span style="margin-left: 4px">{{ localValue }}</span>
          </div>
        </template>
      </staff-popover>
      <template v-else-if="control._type === 'dataDetail'">
        <span v-tip="simpleMode" @click="openDataDetail" :class="from">
          {{ localValue }}
        </span>
      </template>
      <template v-else-if="control._type === 'verifyResult'">
        <div v-if="localValue === '驳回'" class="option-item option-bg-red">
          驳回
        </div>
        <div v-else-if="localValue === '通过'" class="option-item option-bg-green">
          通过
        </div>
      </template>
      <span v-tip="simpleMode" v-else>{{ localValue }}</span>
    </div>
  </div>
</template>

<script>
import FileControl from "./FileControl"
import RefControl from "./RefControl"
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import Rate from "@/components/BaseComponents/Rate"
import { url_prefix } from "@/utils/uploadFile"
import { getUser } from "@/utils/user"
import StaffAvatar from "@/components/StaffAvatar"
import { createZipFile } from "@/api/sheet/sheetData"

export default {
  name: "field-item",
  components: {
    StaffAvatar,
    FileControl,
    RefControl,
    StaffPopover,
    Rate
  },
  props: {
    control: {
      type: Object,
      default: () => ({})
    },
    value: [Number, String, Array, Object, Boolean],
    stringValue: String,
    simpleMode: Boolean, // 是否展示为简略信息
    from: String
  },
  data() {
    return {
      url_prefix
    }
  },
  computed: {
    isEmpty() {
      if (this.control._type == "remark") return [null, ""].includes(this.control.hint)
      return !this.localValue || (Array.isArray(this.localValue) && this.localValue.length == 0)
    },
    localValue() {
      if (this.control._type === "staff") {
        return (this.value || []).map(simpleUser => getUser(simpleUser.id) || simpleUser)
      }
      return ["file", "ref", "rich"].includes(this.control._type) ? this.value : this.stringValue
    },
    hasColor() {
      return this.control._type === "option" && this.control.options?.[0]?.color
    },
    colorMap() {
      if (this.control._type !== "option") return {}
      return this._.chain(this.control.options || [])
        .keyBy("value")
        .mapValues("color")
        .value()
    }
  },
  methods: {
    showFileHistory() {
      this.$refs.fileControl?.showFileHistory(this.control._cid,this.control)
    },
    showFilesInDialog() {
      this.$refs.fileControl?.showFilesInDialog(this.value)
    },
    openDataDetail() {
      if (this.from === "todo") this.$emit("openDataDetail")
    },
    batchDownload() {
      let attachmentIds = this.value?.map(file => file.id)
      let addWaterMark=this.control.aw
      createZipFile(attachmentIds,addWaterMark).then(() =>
        this.$message.success("下载任务已提交，请等待消息通知！")
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.field-item {
  display: flex;
  min-height: 40px;
  align-items: center;
  .label {
    display: flex;
    align-items: center;
    width: 140px;
    min-width: 140px;
    margin-right: 30px;
    line-height: 20px;
    padding: 10px 0;
    .icon-tip {
      font-size: 16px;
      margin-left: 4px;
      &:hover {
        color: #3aacf8;
      }
    }
  }
  .value {
    flex: auto;
    padding: 9px 0;
    overflow: hidden;
    color: #303133;
    .option-item {
      line-height: 22px;
      display: inline-block;
      padding: 0 6px;
      border-radius: 6px;
      color: white;
      margin-right: 5px;
      white-space: nowrap;
    }
    .is-empty {
      color: $color-font-second;
    }
    .sign {
      display: flex;
      background-color: #f5f7fa;
      border-radius: 6px;
    }
    .check {
      ::v-deep {
        .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
          border-color: #fff;
        }
        .el-checkbox__input.is-disabled .el-checkbox__inner {
          background-color: #fff;
          border-color: #dcdfe6;
        }
      }
    }
    .progress {
      ::v-deep {
        .el-progress-circle {
          width: 78px !important;
          height: 78px !important;
        }
        .el-progress__text {
          font-size: 13px !important;
          color: #303133 !important;
        }
      }
    }
    .rich-field {
      ::v-deep p {
        margin: 0;
      }
      ::v-deep {
        ol {
          padding-inline-start: 16px;
        }
        ol li {
          list-style: decimal;
        }
        ul {
          padding-inline-start: 16px;
        }
        ul li {
          list-style: disc;
        }
      }
    }
    .option-item-colorful {
      border-radius: 6px;
      padding: 2px 6px;
      color: white;
      line-height: 17px;
      display: inline-flex;
    }
    .file-button {
      color: #1989fa;
    }
    .todo {
      cursor: pointer;
      color: #198afa;
    }
  }
}
.center {
  display: flex;
  align-items: center;
  margin-right: 4px;
  ::v-deep {
    .el-avatar--small {
      width: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 10px;
    }
  }
}
.background {
  background-color: #eaecf0;
  padding: 2px 4px;
  border-radius: 4px;
}
.background-user {
  background-color: #eaecf0;
  padding: 2px 4px;
  border-radius: 15px;
  width: fit-content;
}
.item-rich {
  width: 100% !important;
  padding-left: unset !important;
}
</style>
